<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()" />
		</div>
		<div class="bg_top">
			<img src="../images/user/five_stars_top.jpg" alt="" />
		</div>
		<div class="btn" @click="getFiveStars">
			<button v-if="data.is_five_stars != 1">立即成为VIP会员</button>
			<button v-else>已成为VIP会员</button>
		</div>
		<div class="bg_bottom">
			<img src="../images/user/five_stars_bottom.jpg" alt="" />
		</div>
	</div>
</template>
<script>
	import Fetch from '../../utils/fetch';
	export default {
		name: "fiveStars",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
			}
		},
		created() {
			this.$parent.footer('fiveStars');
			this.start();
		},
		mounted() {
			
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			getFiveStars() {
				this.$router.push({
					path: '/payment',
					query: {
						type: 7
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>

	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;

		.msg {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 18px;

			img {
				height: 100%;
			}
		}
	}

	.basic_wrap {
		background-color: #fff;
		height: 100vh;
	}

	.btn {
		font-size: 15px;
		text-align: center;
		background: #d82b2b;
		color: #fff;
		border: none;
		width: 44%;
		border-radius: 15px;
		padding: 9px 12px;
		margin: 40px auto 0;
		cursor: pointer;
		font-weight: bold;
		transition: background-color 0.3s;
	}

	.btn:hover {
		background: #f0f0f0;
	}
	
	.bg_top {
		width: 100%;
		
		img {
			width: 100%;
		}
	}
	
	.bg_bottom {
		width: 100%;
		margin-top: 40px;
		
		img {
			width: 100%;
		}
	}
</style>